module.exports = "/dist/assets/images/cart.svg";